import { AxiosRequestConfig, AxiosError, AxiosResponse } from "axios";
import Api from "./Api";
import { LocalizacaoMapaDTO } from "./mapas/LocalizacaoMapaDTO";
import { mapasApiConfig } from "./config";

export class MapaApi extends Api {
  constructor(config: AxiosRequestConfig) {
    super(config);
  }

  obterEnderecos(endereco: string): Promise<LocalizacaoMapaDTO[]> {
    return this.get<LocalizacaoMapaDTO>(`/v1/mapas?endereco=${endereco}`)
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        console.log(error);
        throw new Error("Falha ao obter endereços");
      });
  }

  obterEnderecoPorCep(cep: string): Promise<LocalizacaoMapaDTO> {
    return this.get<LocalizacaoMapaDTO>(`/v1/enderecos?cep=${cep}`)
      .then((endereco: AxiosResponse) => {
        const { data } = endereco;
        return data;
      })
      .catch((error: AxiosError) => {
        console.log(error);
        throw new Error("Falha ao obter endereço por CEP");
      });
  }

  obterGeoLocalizacao(cep: string): Promise<LocalizacaoMapaDTO> {
    return this.get<LocalizacaoMapaDTO>(`/v1/mapas?endereco=${cep}`)
      .then((endereco: AxiosResponse) => {
        const { data } = endereco;
        return data[0];
      })
      .catch((error: AxiosError) => {
        console.log(error);
        throw new Error("Falha ao obter endereço por CEP");
      });
  }
}

export const mapaApi = new MapaApi(mapasApiConfig);